import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import xdk from '@accedo/xdk-core';

import { toggleSpinner } from '#/redux/modules/spinner/actions';
import {
  setVideoPlayTime,
  startPlaybackTimer,
  stopPlaybackTimer,
} from '#/redux/modules/appPlayer/actions';
import { getVideoCaptionEnabled } from '#/redux/modules/appPlayer/selectors';
import ClosedCaption from '#/components/Player/ClosedCaption';
import styles from './LivePlayer.scss';

const LivePlayer = ({ url }) => {
  const dispatch = useDispatch();
  const videoContainerRef = useRef();
  const ccEnabled = useSelector(getVideoCaptionEnabled);

  const onStateChanged = async ({ from, to }) => {
    const MEDIASTATE = xdk.CONSTANT.MEDIA.STATE;
    if (from === MEDIASTATE.CONNECTING && to !== MEDIASTATE.STOPPED) {
      // loaded live stream, load subtitles if they exist and set live stream start play time
      await xdk.media.getSubtitles();
      if (ccEnabled) {
        await xdk.media.showSubtitle(0);
      }
      dispatch(setVideoPlayTime());
    }
    if (to === MEDIASTATE.PLAYING) {
      dispatch(startPlaybackTimer());
    } else if (to === MEDIASTATE.STOPPED || to === MEDIASTATE.PAUSED) {
      dispatch(stopPlaybackTimer());
    }
  };

  useEffect(() => {
    if (url && videoContainerRef.current) {
      xdk.media?.load(url, {
        parentNode: videoContainerRef.current,
        live: true,
      });
      xdk.environment.addEventListener(
        xdk.environment.MEDIA.STATE_CHANGED,
        onStateChanged,
      );

      requestAnimationFrame(() => {
        dispatch(toggleSpinner(false));
      });

      return () => {
        xdk.environment.removeEventListener(
          xdk.environment.MEDIA.STATE_CHANGED,
          onStateChanged,
        );
        xdk.media?.deinit();
      };
    }
    return () => xdk.media?.deinit();
  }, [url, videoContainerRef.current]);

  return (
    <>
      <div className={styles.container} ref={videoContainerRef} />
      {ccEnabled && <ClosedCaption />}
    </>
  );
};

LivePlayer.propTypes = {
  url: PropTypes.string,
};

export default LivePlayer;
